import { NavigateFunction, useNavigate } from 'react-router-dom';

const onNavigate = (navigate: NavigateFunction, path: string) => navigate('../' + path);

export const useRouteHook = () => {
  const navigate = useNavigate();

  return {
    navigate: (path: string) => onNavigate(navigate, path),
    back: () => navigate(-1),
  };
};
